"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UqeProductsEventActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["UqeCustomerEvent"] = "UqeCustomerEvent";
    EventTypes["UqeDivisionProductsEvent"] = "UqeDivisionProductsEvent";
    EventTypes["UqeDivisionPimGroupEvent"] = "UqeDivisionPimGroupEvent";
    EventTypes["UqeDivisionEvent"] = "UqeDivisionEvent";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var UqeProductsEventActions;
(function (UqeProductsEventActions) {
    UqeProductsEventActions["UqeCustomerEventCreated"] = "UqeCustomerEventCreated";
    UqeProductsEventActions["UqeDivisionProductsEventCreated"] = "UqeDivisionProductsEventCreated";
    UqeProductsEventActions["UqeDivisionPimGroupEventCreated"] = "UqeDivisionPimGroupEventCreated";
    UqeProductsEventActions["UqeDivisionEventCreated"] = "UqeDivisionEventCreated";
})(UqeProductsEventActions = exports.UqeProductsEventActions || (exports.UqeProductsEventActions = {}));
